const normalizeCityName = (name: string): string =>
  name.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()

const findLongestCommonSubsequence = (
  city1: string,
  city2: string
): { shortestLength: number; longestCommonSubsequence: number } => {
  let longestCommonSubsequence = 0
  const shortestLength = Math.min(city1.length, city2.length)

  for (let i = 0; i < city1.length; i++) {
    let matchLength = 0
    for (let j = 0; j < city2.length; j++) {
      if (city1[i] === city2[j]) {
        matchLength = 1
        while (
          i + matchLength < city1.length &&
          j + matchLength < city2.length &&
          city1[i + matchLength] === city2[j + matchLength] &&
          matchLength < shortestLength
        ) {
          matchLength++
        }
        longestCommonSubsequence = Math.max(
          longestCommonSubsequence,
          matchLength
        )
      }
    }
  }

  return { longestCommonSubsequence, shortestLength }
}

export const checkAreCitiesSimilar = (
  city1: string,
  city2: string,
  minMatches = 4
): boolean => {
  const normalized1 = normalizeCityName(city1)
  const normalized2 = normalizeCityName(city2)

  if (normalized1.length < minMatches || normalized2.length < minMatches) {
    return normalized1 === normalized2
  }

  const MATCH_RATE = 0.8

  const { longestCommonSubsequence, shortestLength } =
    findLongestCommonSubsequence(normalized1, normalized2)

  return longestCommonSubsequence >= shortestLength * MATCH_RATE
}
